import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class StorageAbandoned1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.STORAGE_ABANDONED1;
}

export default StorageAbandoned1PoiTileEntity;
